import BoxWidget from '@/components/box-widget/BoxWidget.vue';
import { initDycolor, permissions, adapi } from '~';
import { mapActions, mapGetters, mapState } from 'vuex';

initDycolor('suspend-resume-box', require(`${process.env.DYCOLOR_REQUIRE}./SuspendResumeBox.scss`)); // eslint-disable-line

export default {
  components: {
    'box-widget': BoxWidget,
  },
  methods: {
    ...mapActions('campaign', ['reloadCampaign']),
    suspendCampaign() {
      return adapi.post(`campaigns/${this.current.code}/suspend`)
        .then(() => {
          this.$toast.success({ message: this.$t('pos.campaign.campaign-suspended-text') });
        })
        .then(() => this.reloadCampaign())
        .catch(error => {
          this.$toast.error({ message: String(error) });
        });
    },
    resumeCampaign() {
      return adapi.post(`campaigns/${this.current.code}/resume`)
        .then(() => {
          this.$toast.success({ message: this.$t('pos.campaign.campaign-resume-text') });
        })
        .then(() => this.reloadCampaign())
        .catch(error => {
          this.$toast.error({ message: String(error) });
        });
    },
  },
  computed: {
    ...mapGetters('campaign', {
      campaign: 'currentCampaign',
    }),
    ...mapState('campaign', {
      current: 'current',
      error: 'error',
    }),
    permissions() {
      return permissions.getPermissions(this.campaign);
    },
    canSuspendCampaign() {
      return this.permissions.includes('suspend');
    },
    canResumeCampaign() {
      return this.permissions.includes('resume');
    },
  },
  mounted() {
  },
};



// WEBPACK FOOTER //
// ./src/components/suspend-resume-box/SuspendResumeBox.js